<template>
    <transiton name="fade">
        <div class="container col-xs-12" v-if="showAlert">
            <div class="popup" :class="{'video-height': counts <=0}">
                <div class="title clearfix">
                    <span>{{title}}</span>
                    <a @click="colse"><span>X</span></a>
                </div>
                <div v-if="youtubeUrl">
                  <iframe :src="youtubeUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
              <div class="video-bottom-list" v-if="counts > 0">
              <!-- clearfix -->
              <ul class="" >
                <li v-for="(video,index) in videoList" :class="{'is-check' : index == current}" :key="video.id" @click="changeUrl(video.youtube_id,index,video.file_names)" style="width: 230px; display: inline-block; cursor: pointer">
                  <img class="video-img" :src="'http://img.youtube.com/vi/' + video.youtube_id + '/default.jpg'" alt="">
                  <div class="video-title">
                    <h5 style="-webkit-box-orient: vertical;">{{video.file_names}}</h5>
                    <span>日期：{{video.create_time*1000|datefmt("YYYY.MM.DD")}}</span>
                  </div>
                </li>
                <!--<li class="" style="width: 230px; display: inline-block;">-->
                    <!--<img class="video-img" src="@/assets/image/thumbil.png" alt="">-->
                  <!--<div class="video-title">-->
                    <!--<h5 >第26屆滙業盃總第26屆滙業盃總26屆滙業盃總</h5>-->
                    <!--<span>日期：2018.12.10</span>-->
                  <!--</div>-->
                <!--</li>-->
              </ul>

              </div>
            </div>
        </div>
    </transiton>
</template>

<script>
export default{
  name: 'alert',
  data () {
    return {
      showAlert: false,
      videoList: [],
      counts: 0,
      youtubeUrl: '',
      title: '',
      current: 0
    }
  },
  methods: {
    show: function (index = 0, youtubeId, videoList = [], title = '') {
      var that = this
      this.youtubeUrl = 'https://www.youtube.com/embed/' + youtubeId
      this.videoList = videoList
      this.counts = videoList.length
      this.title = title
      if (this.counts > 0) {
        this.current = index
        $.each(videoList, function (i, item) {
          if (item['youtube_id'] === youtubeId) {
            that.title = item['file_names']
          }
        })
      }
      this.showAlert = true
    },
    colse: function () {
      this.showAlert = false
    },
    changeUrl: function (youtubeId, index, title) {
      this.current = index
      this.title = title
      this.youtubeUrl = 'https://www.youtube.com/embed/' + youtubeId
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clearfix:after{
        display: block;
        visibility: hidden;
        clear: both;
        height: 0;
        content: ".";
    }
    .clearfix{
        zoom: 1;
    }
    .container{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.42);
        z-index: 1;
        transition: all .3s ease-in-out;
    }

    .popup{
        position: relative;
        margin: 5% auto 0;
        /*width: 434px;*/
        width: 750px;
        height: 600px;
        z-index: 5;
        background: #000000;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
        border-radius: 7px;
    }
    .popup .title{
        border-radius: 7px 7px 0 0;
        background:#ffffff;
        padding: 10px 20px;
        border-bottom: solid 5px #617BE4;
    }
    .popup .title span{
      display: inline-block;
      width: 85%;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      font-size: 16px;
    }
    .popup .title a{
      float: right;
      /*margin-top: 10px;*/
      margin-right: 10px;
      display: inline-block;
      /*line-height: 25px;*/
      border: 2px solid #617BE4;
      width: 25px;
      height: 25px;
      border-radius: 25px;
      color: #617BE4;
      /*font-size: 25px;*/
      text-decoration: none;
      cursor: pointer;
      text-align: center;
    }
    .popup .title a span{
      display: inline;
      font-size: 16px;
      margin-top: 2px;
    }
    .popup iframe{
      width: 100%;
      min-height: 400px;
    }
    .video-height{
      height: 455px;
    }
    .video-bottom-list{
      overflow-y: scroll;
      height: 130px;
      /*border-bottom-right-radius: 55px;*/
    }

    .video-bottom-list::-webkit-scrollbar
    {
      width: 7px;
      background-color:#000;
    }
    .video-bottom-list::-webkit-scrollbar-thumb
    {
      border-radius: 10px;
      width: 7px;
      height:100px;
      -webkit-box-shadow: inset 0 0 6px rgba(216,216,216,0.33);
      background-color: #555;
    }

    .video-bottom-list ul{
      padding-left: 15px;
    }

    .video-bottom-list ul li{
      height: 90px;
    }
    .video-bottom-list ul li:hover{
      background:rgba(151,151,151,0.2);
    }

    .video-bottom-list .is-check{
      background:rgba(151,151,151,0.2);
    }
    .video-img{
      display: inline-block;
      width: 80px;
      height: 70px;
      margin-top: -40px;
    }
    .video-title{
      margin-top: 10px;
      /*float: right;*/
      display: inline-block;
      width: 140px;
    }

    .video-title h5{
      color: #ffffff;
      /*text-overflow:ellipsis;*/
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 30px;
      overflow: hidden;
    }
    .video-title span{
      color: #6D7074;
    }

  @media (max-width: 767px) {

    .popup{
      margin: 40% auto 0;
      width: 300px;
      height: 400px;
    }
    .popup .title{
      border-bottom: solid 3px #617BE4;
    }
    /*.popup .title span{*/
      /*font-size: 12px;*/
    /*}*/
    .popup .title a{
      margin-top: 3px;
      line-height: 15px;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      font-size: 20px;
    }

    .popup iframe{
      width: 100%;
      min-height: 200px;
    }
    .video-height{
      height: 250px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/titbits/albumVideo.vue